import api from './axios'

// 튜토리얼 여부 체크
export const checkTutorial = async(page) => {
  const res = await api.get(`users/tutorial/check/${page}`)
  return res.data
}

// 튜토리얼 완료 저장
export const logTutorial = async(page) => {
  return await api.post(`users/tutorial/log/${page}`);
};